/**
 * Custom Tarps Color & Fabric Management
 * Handles material-aware switching, option filtering, and specs/image updates.
 */

(function () {
  'use strict';

  var CustomTarpsColors = {
    config: null,
    currentFabric: null,
    currentWeight: null,
    currentSubWeight: null,
    currentColor: null,
    colorMetaobjects: [],
    _userInteracted: false,

    hideSectionsAndClearSelections: function () {
      var weightSections = document.querySelectorAll('.custom-tarps-weight');
      weightSections.forEach(function (el) { el.style.display = 'none'; });

      var subweightSections = document.querySelectorAll('#customTarpsSubweightStep, .custom-tarps-subweight');
      subweightSections.forEach(function (el) { el.style.display = 'none'; });

      var colorSections = document.querySelectorAll('.custom-tarps-color');
      colorSections.forEach(function (el) { el.style.display = 'none'; });

      var fastenerSections = document.querySelectorAll('.custom-tarps-fasteners');
      fastenerSections.forEach(function (el) { el.style.display = 'none'; });

      var accessorySections = document.querySelectorAll('.custom-tarps-accessories');
      accessorySections.forEach(function (el) { el.style.display = 'none'; });

      var weightRadios = document.querySelectorAll('.custom-tarps-weight-radio');
      weightRadios.forEach(function (r) {
        r.checked = false;
        r.disabled = true;
      });
      var weightOptions = document.querySelectorAll('.custom-tarps-weight-option');
      weightOptions.forEach(function (opt) {
        opt.style.display = 'none';
      });

      var subweightRadios = document.querySelectorAll('.custom-tarps-subweight-radio');
      subweightRadios.forEach(function (r) {
        r.checked = false;
        r.disabled = true;
      });
      var subweightOptions = document.querySelectorAll('.custom-tarps-subweight-option');
      subweightOptions.forEach(function (opt) {
        opt.style.display = 'none';
      });

      var colorRadios = document.querySelectorAll('.custom-tarps-color-radio');
      colorRadios.forEach(function (r) {
        r.checked = false;
        r.disabled = true;
      });
      var colorOptions = document.querySelectorAll('.custom-tarps-color-option');
      colorOptions.forEach(function (opt) {
        opt.style.display = 'none';
      });

      var fastenerRadios = document.querySelectorAll('.custom-tarps-fastener-radio, .custom-tarps-grommet-radio');
      fastenerRadios.forEach(function (r) {
        r.checked = false;
      });

      var defaultGrommet = document.getElementById('fastener-grommet-24') || document.getElementById('grommet-24');
      if (defaultGrommet) {
        defaultGrommet.checked = false;
      }

      var grommetPropEl = document.getElementById('customTarpsGrommetSpacingProperty');
      if (grommetPropEl) {
        grommetPropEl.value = '';
        grommetPropEl.disabled = true;
      }

      var webbingEl = document.getElementById('accessory-webbing');
      if (webbingEl) {
        webbingEl.checked = false;
        webbingEl.disabled = true;
        webbingEl.setAttribute('aria-disabled', 'true');
      }
      var webbingContainer = webbingEl ? webbingEl.closest('.custom-tarps-accessory') : null;
      if (webbingContainer) {
        webbingContainer.classList.add('is-disabled');
      }
      var badgeEl = document.getElementById('accessory-webbing-badge');
      if (badgeEl) {
        badgeEl.style.display = 'none';
      }
      var accPropEl = document.getElementById('customTarpsAccessoryProperty');
      if (accPropEl) {
        accPropEl.value = '';
        accPropEl.disabled = true;
      }

      var hiddenFabricEl = document.getElementById('customTarpsBaseFabric');
      if (hiddenFabricEl) {
        hiddenFabricEl.value = '';
      }

      this.currentFabric = null;
      this.currentWeight = null;
      this.currentSubWeight = null;
      this.currentColor = null;

      this.updateSelectedColorLabel();
      this.updateMaterialSpecs();
      this.updateLegendLabel();
      this.updateFeatureIcons();
      this.updateBestsellerSizes();
    },

    init: function (config) {
      this.config = config;
      var metaobjectsEl = document.getElementById('customTarpsColorsMetaobjectsJson');
      this.colorMetaobjects = [];
      if (metaobjectsEl) {
        try {
          this.colorMetaobjects = JSON.parse(metaobjectsEl.textContent);
        } catch (e) {
          console.error('Failed to parse color metaobjects:', e);
        }
      }
      this.bindEvents();
      this.initializeSelections();

      if (!this.currentFabric) {
        this.hideSectionsAndClearSelections();
      } else {
        // Update display states on load
        this.updateLegendLabel();
        this.updateWeightOptions();
        this.updateSubWeightOptions();
        this.updateColorOptions();
        this.updateSelectedColorLabel();
        this.updateMaterialSpecs();
        this.updateMediaGallery();
      }
      this.initStickyGalleryObserver();
    },

    bindEvents: function () {
      var self = this;

      // Fabric selection change
      document.addEventListener('change', function (e) {
        if (e.target.classList.contains('custom-tarps-fabric-radio')) {
          if (e.target.checked) {
            self.onFabricChange(e.target.getAttribute('data-fabric-id'));
          } else {
            var anyChecked = document.querySelector('.custom-tarps-fabric-radio:checked');
            self.onFabricChange(anyChecked ? anyChecked.getAttribute('data-fabric-id') : null);
          }
        }
      });

      // Weight selection change
      document.addEventListener('change', function (e) {
        if (e.target.classList.contains('custom-tarps-weight-radio')) {
          self.onWeightChange(e.target.getAttribute('data-weight-id'));
        }
      });

      // Sub-weight / Sub-variation selection change
      document.addEventListener('change', function (e) {
        if (e.target.classList.contains('custom-tarps-subweight-radio')) {
          self.onSubWeightChange(e.target.getAttribute('data-subweight-id'));
        }
      });

      // Color selection change
      document.addEventListener('change', function (e) {
        if (e.target.classList.contains('custom-tarps-color-radio')) {
          self.onColorChange(e.target.value);
        }
      });
    },

    initializeSelections: function () {
      var selectedFabric = document.querySelector('.custom-tarps-fabric-radio:checked');
      var selectedWeight = document.querySelector('.custom-tarps-weight-radio:checked:not(:disabled)');
      var selectedSubWeight = document.querySelector('.custom-tarps-subweight-radio:checked:not(:disabled)');
      var selectedColor = document.querySelector('.custom-tarps-color-radio:checked:not(:disabled)');

      this.currentFabric = selectedFabric ? selectedFabric.getAttribute('data-fabric-id') : null;
      this.currentWeight = selectedWeight ? selectedWeight.getAttribute('data-weight-id') : null;
      this.currentSubWeight = selectedSubWeight ? selectedSubWeight.getAttribute('data-subweight-id') : null;
      this.currentColor = selectedColor ? selectedColor.value : null;
      this.updateSelectedColorLabel();
    },

    onFabricChange: function (fabricId) {
      this._userInteracted = true;

      if (!fabricId) {
        this.hideSectionsAndClearSelections();
        if (window.customTarpsCalculatePrice) {
          window.customTarpsCalculatePrice();
        }
        return;
      }

      this.currentFabric = fabricId;

      var hiddenFabricEl = document.getElementById('customTarpsBaseFabric');
      if (hiddenFabricEl) {
        var fabricRadio = document.querySelector('.custom-tarps-fabric-radio[data-fabric-id="' + fabricId + '"]');
        if (fabricRadio) {
          hiddenFabricEl.value = fabricRadio.value;
        }
      }

      // Display the weight, color, fasteners, and accessories sections
      var weightSections = document.querySelectorAll('.custom-tarps-weight');
      weightSections.forEach(function (el) { el.style.display = ''; });

      var colorSections = document.querySelectorAll('.custom-tarps-color');
      colorSections.forEach(function (el) { el.style.display = ''; });

      var fastenerSections = document.querySelectorAll('.custom-tarps-fasteners');
      fastenerSections.forEach(function (el) { el.style.display = ''; });

      var accessorySections = document.querySelectorAll('.custom-tarps-accessories');
      accessorySections.forEach(function (el) { el.style.display = ''; });

      this.updateLegendLabel();
      this.updateWeightOptions();
      this.updateSubWeightOptions();
      this.updateColorOptions();
      this.updateSelectedColorLabel();

      // Initialize default fastener: check fastener-grommet-24 (or #grommet-24), set customTarpsGrommetSpacingProperty to 'Every 24"', and trigger change
      var defaultGrommet = document.getElementById('fastener-grommet-24') || document.getElementById('grommet-24');
      if (defaultGrommet) {
        defaultGrommet.checked = true;
        var grommetProp = document.getElementById('customTarpsGrommetSpacingProperty');
        if (grommetProp) {
          grommetProp.disabled = false;
          grommetProp.value = 'Every 24"';
        }
        try {
          defaultGrommet.dispatchEvent(new Event('change', { bubbles: true }));
        } catch (e) {
          // fallback if Event constructor fails in legacy envs
        }
      }

      this.updateFeatureIcons();
      this.updateBestsellerSizes();
      this.updateMaterialSpecs();
      this.updateMediaGallery();
      this.updateMainImage();

      if (typeof window.customTarpsSyncAccessories === 'function') {
        window.customTarpsSyncAccessories();
      }

      if (window.customTarpsCalculatePrice) {
        window.customTarpsCalculatePrice();
      }
    },

    onWeightChange: function (weightId) {
      this._userInteracted = true;
      this.currentWeight = weightId;
      this.updateSubWeightOptions();
      this.updateColorOptions();
      this.updateSelectedColorLabel();
      this.updateFeatureIcons();
      this.updateMaterialSpecs();
      this.updateMainImage();

      if (window.customTarpsCalculatePrice) {
        window.customTarpsCalculatePrice();
      }
    },

    onSubWeightChange: function (subWeightId) {
      this._userInteracted = true;
      this.currentSubWeight = subWeightId;
      this.updateColorOptions();
      this.updateSelectedColorLabel();
      this.updateFeatureIcons();
      this.updateMaterialSpecs();
      this.updateMainImage();

      if (window.customTarpsCalculatePrice) {
        window.customTarpsCalculatePrice();
      }
    },

    onColorChange: function (colorLabel) {
      this._userInteracted = true;
      this.currentColor = colorLabel;
      this.updateSelectedColorLabel();
      this.updateMainImage();
    },

    updateSelectedColorLabel: function () {
      var displayEl = document.getElementById('customTarpsSelectedColorVal');
      if (!displayEl) return;
      var selectedRadio = document.querySelector('.custom-tarps-color-radio:checked:not(:disabled)');
      var labelVal = selectedRadio ? selectedRadio.value : this.currentColor;
      if (labelVal) {
        var lower = (labelVal || '').trim().toLowerCase();
        if (lower === 'natural' || lower === 'natural canvas' || lower === 'natural/untreated' || lower === 'untreated' || lower === 'off white' || lower === 'off-white') {
          labelVal = 'Natural/Off White';
        }
        displayEl.textContent = ': ' + labelVal;
      } else {
        displayEl.textContent = '';
      }
    },

    updateLegendLabel: function () {
      var legendEl = document.getElementById('weightLegend');
      if (!legendEl) return;
      if (!this.currentFabric) {
        legendEl.textContent = 'Weight';
        return;
      }
      if (!this.config || !this.config.fabrics) return;
      var self = this;
      var fabric = this.config.fabrics.find(function (f) {
        return f.id === self.currentFabric;
      });
      var category = fabric && fabric.variationCategory ? fabric.variationCategory : 'Weight';
      legendEl.textContent = category;
    },

    updateFeatureIcons: function () {
      var groups = document.querySelectorAll('.custom-tarps-features-group');
      if (!this.currentFabric || !this.currentWeight) {
        groups.forEach(function (group) {
          group.style.display = 'none';
        });
        return;
      }
      var self = this;
      groups.forEach(function (group) {
        var groupFabric = group.getAttribute('data-fabric-id');
        var groupWeight = group.getAttribute('data-weight-id');
        if (groupFabric === self.currentFabric && groupWeight === self.currentWeight) {
          group.style.display = 'flex';
        } else {
          group.style.display = 'none';
        }
      });
    },

    updateBestsellerSizes: function () {
      var buttons = document.querySelectorAll('#customTarpsBestSizes .best-size');
      if (!buttons.length) return;
      if (!this.currentFabric) {
        buttons.forEach(function (btn) {
          btn.style.display = 'none';
        });
        return;
      }
      var self = this;
      buttons.forEach(function (btn) {
        var btnFabric = btn.getAttribute('data-fabric-id');
        var btnWeight = btn.getAttribute('data-weight-id');
        var matches = (btnFabric === self.currentFabric) && (!btnWeight || btnWeight === self.currentWeight);
        if (matches) {
          btn.style.display = '';
        } else {
          btn.style.display = 'none';
        }
      });
    },

    updateSubWeightOptions: function () {
      var stepEl = document.getElementById('customTarpsSubweightStep');
      if (!this.currentFabric || !this.currentWeight) {
        if (stepEl) stepEl.style.display = 'none';
        var allSub = document.querySelectorAll('.custom-tarps-subweight-option');
        allSub.forEach(function (opt) {
          opt.style.display = 'none';
          var input = opt.querySelector('input');
          if (input) {
            input.disabled = true;
            input.checked = false;
          }
        });
        this.currentSubWeight = null;
        return;
      }
      var self = this;
      var options = document.querySelectorAll('.custom-tarps-subweight-option');
      var hasVisible = false;
      var firstChecked = false;
      this.currentSubWeight = null;

      options.forEach(function (option) {
        var optFabric = option.getAttribute('data-fabric-id');
        var optWeight = option.getAttribute('data-weight-id');
        var input = option.querySelector('input');
        if (optFabric === self.currentFabric && optWeight === self.currentWeight) {
          option.style.display = 'inline-flex';
          hasVisible = true;
          if (input) {
            input.disabled = false;
            if (!firstChecked) {
              input.checked = true;
              self.currentSubWeight = input.getAttribute('data-subweight-id');
              firstChecked = true;
            } else {
              input.checked = false;
            }
          }
        } else {
          option.style.display = 'none';
          if (input) {
            input.disabled = true;
            input.checked = false;
          }
        }
      });

      if (stepEl) {
        stepEl.style.display = hasVisible ? '' : 'none';
      }
    },

    updateColorOptions: function () {
      if (!this.currentFabric || !this.currentWeight) {
        var allColors = document.querySelectorAll('.custom-tarps-color-option');
        allColors.forEach(function (opt) {
          opt.style.display = 'none';
          var input = opt.querySelector('input');
          if (input) {
            input.disabled = true;
            input.checked = false;
          }
        });
        this.currentColor = null;
        this.updateSelectedColorLabel();
        return;
      }
      var self = this;
      var colorOptions = document.querySelectorAll('.custom-tarps-color-option');
      var firstChecked = false;
      this.currentColor = null;

      colorOptions.forEach(function (option) {
        var optFabricId = option.getAttribute('data-fabric-id');
        var optWeightId = option.getAttribute('data-weight-id');
        var optSubId = option.getAttribute('data-subweight-id');
        var input = option.querySelector('input');

        var matches = (optFabricId === self.currentFabric && optWeightId === self.currentWeight);
        if (matches && self.currentSubWeight && optSubId) {
          matches = (optSubId === self.currentSubWeight);
        }

        if (matches) {
          option.style.display = '';
          if (input) {
            input.disabled = false;
            if (!firstChecked) {
              input.checked = true;
              self.currentColor = input.value;
              firstChecked = true;
            } else {
              input.checked = false;
            }
          }
        } else {
          option.style.display = 'none';
          if (input) {
            input.disabled = true;
            input.checked = false;
          }
        }
      });

      this.updateSelectedColorLabel();
    },

    updateWeightOptions: function () {
      if (!this.currentFabric) {
        var allWeightOptions = document.querySelectorAll('.custom-tarps-weight-option');
        allWeightOptions.forEach(function (option) {
          option.style.display = 'none';
          var input = option.querySelector('input');
          if (input) {
            input.disabled = true;
            input.checked = false;
          }
        });
        this.currentWeight = null;
        return;
      }
      var self = this;
      var weightOptions = document.querySelectorAll('.custom-tarps-weight-option');
      var firstChecked = false;

      weightOptions.forEach(function (option) {
        var optionFabricId = option.getAttribute('data-fabric-id');
        var input = option.querySelector('input');
        if (optionFabricId === self.currentFabric) {
          option.style.display = 'inline-flex';
          if (input) {
            input.disabled = false;
            if (!firstChecked) {
              input.checked = true;
              self.currentWeight = input.getAttribute('data-weight-id');
              firstChecked = true;
            } else {
              input.checked = false;
            }
          }
        } else {
          option.style.display = 'none';
          if (input) {
            input.disabled = true;
            input.checked = false;
          }
        }
      });
    },

    updateMainImage: function () {
      var self = this;
      if (!this.currentColor) return;

      var colorLower = (this.currentColor || '').trim().toLowerCase();

      // 1. Check if gallery viewer or thumbnails have a media slide matching the alt tag
      var galleryEl = document.querySelector('media-gallery');
      var switchedByAlt = false;

      if (galleryEl) {
        var mediaItems = galleryEl.querySelectorAll('.thumbnail-list__item, .product__media-item');
        for (var k = 0; k < mediaItems.length; k++) {
          var item = mediaItems[k];
          var img = item.querySelector('img');
          if (img && img.alt) {
            var altText = img.alt.trim().toLowerCase();
            if (altText === colorLower || altText.indexOf(colorLower) !== -1 ||
               ((colorLower === 'natural/off white' || colorLower === 'natural / off white' || colorLower === 'off white') && (altText.indexOf('natural') !== -1 || altText.indexOf('untreated') !== -1 || altText.indexOf('off white') !== -1))) {
              var btn = item.querySelector('button');
              if (btn) {
                btn.click();
                switchedByAlt = true;
                break;
              } else if (item.getAttribute('data-target')) {
                var targetId = item.getAttribute('data-target');
                if (typeof galleryEl.setActiveMedia === 'function') {
                  galleryEl.setActiveMedia(targetId, true);
                  switchedByAlt = true;
                  break;
                }
              }
            }
          }
        }
      }

      // 2. Check selected color radio data attributes first, then metaobjects
      var imageUrl = null;
      var selectedRadio = document.querySelector('.custom-tarps-color-radio:checked:not(:disabled)');
      if (selectedRadio) {
        imageUrl = selectedRadio.getAttribute('data-product-image');
        if (!imageUrl) {
          var labelEl = document.querySelector('label[for="' + selectedRadio.id + '"]');
          if (labelEl) {
            imageUrl = labelEl.getAttribute('data-product-image') || labelEl.getAttribute('data-swatch-image');
          }
        }
      }

      if (!imageUrl) {
        var matchedColor = this.colorMetaobjects.find(function (item) {
          var itemLabel = (item.label || '').trim().toLowerCase();
          if (itemLabel === colorLower) return true;
          if ((colorLower === 'natural/off white' || colorLower === 'natural / off white' || colorLower === 'off white') &&
              (itemLabel === 'natural' || itemLabel === 'natural canvas' || itemLabel === 'untreated' || itemLabel === 'natural/untreated' || itemLabel === 'off white' || itemLabel === 'natural/off white')) {
            return true;
          }
          return false;
        });
        if (matchedColor && (matchedColor.image || matchedColor.product_image)) {
          imageUrl = matchedColor.product_image || matchedColor.image;
        }
      }

      // 3. Apply image update to main active media image if available
      if (imageUrl && !switchedByAlt) {
        var mainImgSelectors = [
          '.product__media-item.is-active img',
          'media-gallery .grid__item.is-active img',
          'media-gallery img',
          '.product__media-wrapper img',
          '[id^="ProductInfo-"] ~ .product__media-wrapper img'
        ];

        var imgEl = null;
        for (var i = 0; i < mainImgSelectors.length; i++) {
          imgEl = document.querySelector(mainImgSelectors[i]);
          if (imgEl) break;
        }

        if (imgEl) {
          imgEl.src = imageUrl;
          imgEl.srcset = imageUrl;
          if (imgEl.getAttribute('data-zoom')) {
            imgEl.setAttribute('data-zoom', imageUrl);
          }
        }
      }

      var event = new CustomEvent('customTarpsImageUpdate', {
        detail: {
          fabric: this.currentFabric,
          weight: this.currentWeight,
          color: this.currentColor,
          imageUrl: imageUrl
        }
      });
      document.dispatchEvent(event);
    },

    updateMaterialSpecs: function () {
      var specsEl = document.getElementById('materialSpecs');
      if (!this.currentFabric || !this.currentWeight) {
        if (specsEl) specsEl.style.display = 'none';
        return;
      }
      var self = this;

      var blocks = document.querySelectorAll('.custom-tarps-spec-block');
      var matchedCount = 0;

      blocks.forEach(function (block) {
        var blockFabricId = block.getAttribute('data-fabric-id');
        var blockWeightId = block.getAttribute('data-weight-id');
        var blockSubId = block.getAttribute('data-subweight-id');

        var matches = (blockFabricId === self.currentFabric && blockWeightId === self.currentWeight);
        if (matches && self.currentSubWeight && blockSubId) {
          matches = (blockSubId === self.currentSubWeight);
        }

        if (matches) {
          block.hidden = false;
          block.style.display = 'block';
          matchedCount++;
        } else {
          block.hidden = true;
          block.style.display = 'none';
        }
      });

      // Fallback: If sub-weight match didn't find specific block, match main variation block
      if (matchedCount === 0) {
        blocks.forEach(function (block) {
          var blockFabricId = block.getAttribute('data-fabric-id');
          var blockWeightId = block.getAttribute('data-weight-id');
          var blockSubId = block.getAttribute('data-subweight-id');

          if (blockFabricId === self.currentFabric && blockWeightId === self.currentWeight && !blockSubId) {
            block.hidden = false;
            block.style.display = 'block';
            matchedCount++;
          }
        });
      }

      var specsEl = document.getElementById('materialSpecs');
      if (specsEl) {
        specsEl.style.display = (matchedCount > 0 ? 'block' : 'none');
      }
    },

    getFabricName: function (fabricId) {
      if (!this.config.fabrics) return fabricId;

      var fabric = this.config.fabrics.find(function (f) {
        return f.id === fabricId;
      });

      return fabric ? fabric.name : fabricId;
    },

    parseSpecText: function (specText, fabricId) {
      var parts = {
        thickness: 'N/A',
        durability: 'N/A',
        description: specText || ''
      };

      if (!specText) return parts;

      // Extract thickness (e.g., "10 mil thickness" or just "10 mil")
      var thicknessMatch = specText.match(/(\d+\s*mil)\s*(?:thickness)?/i);
      if (thicknessMatch) {
        parts.thickness = thicknessMatch[1];
      } else if (fabricId === 'poly' && this.currentWeight) {
        // Fallback for Poly where weight selection is thickness itself
        parts.thickness = this.currentWeight.replace('mil', ' mil');
      }

      // Extract durability (e.g., "Standard duty", "Heavy duty", "Ultra heavy duty")
      var durabilityMatch = specText.match(/([^,.]*duty)/i);
      if (durabilityMatch) {
        parts.durability = durabilityMatch[1].trim();
      }

      // Clean up description
      var cleanDesc = specText;
      if (thicknessMatch) {
        cleanDesc = cleanDesc.replace(new RegExp(thicknessMatch[0] + '\\s*(?:thickness)?,?\\s*', 'i'), '');
      }
      if (durabilityMatch) {
        cleanDesc = cleanDesc.replace(new RegExp(durabilityMatch[0] + '\\s*,?\\s*', 'i'), '');
      }
      parts.description = cleanDesc.trim();

      return parts;
    },

    updateMediaGallery: function () {
      var activeFabric = this.currentFabric;
      if (!activeFabric) return;

      var galleryEl = document.querySelector('media-gallery');
      if (!galleryEl) return;

      var sectionId = galleryEl.id ? galleryEl.id.replace('MediaGallery-', '') : '';
      var galleryViewerList = document.getElementById('Slider-Gallery-' + sectionId);
      var galleryThumbnailsList = document.getElementById('Slider-Thumbnails-' + sectionId);
      var sliderCounterTotal = galleryEl.querySelector('.slider-counter--total');

      if (!galleryViewerList) return;

      // Cache default product media gallery HTML on first run
      if (!galleryEl._defaultSlidesHTML) {
        galleryEl._defaultSlidesHTML = galleryViewerList.innerHTML;
        galleryEl._defaultThumbnailsHTML = galleryThumbnailsList ? galleryThumbnailsList.innerHTML : '';
        galleryEl._defaultTotalCount = sliderCounterTotal ? sliderCounterTotal.textContent : '';
      }

      // Look for template for this fabric category
      var template = document.getElementById('FabricGalleryTemplate-' + sectionId + '-' + activeFabric) ||
                     document.getElementById('FabricGalleryTemplate-' + activeFabric);

      if (template) {
        var slidesWrapper = template.content ? template.content.querySelector('[data-gallery-slides]') : template.querySelector('[data-gallery-slides]');
        var thumbnailsWrapper = template.content ? template.content.querySelector('[data-gallery-thumbnails]') : template.querySelector('[data-gallery-thumbnails]');
        var count = template.getAttribute('data-media-count');

        if (slidesWrapper) {
          galleryViewerList.innerHTML = slidesWrapper.innerHTML;
        }
        if (galleryThumbnailsList && thumbnailsWrapper) {
          galleryThumbnailsList.innerHTML = thumbnailsWrapper.innerHTML;
        }
        if (sliderCounterTotal && count) {
          sliderCounterTotal.textContent = count;
        }
      } else {
        // Revert to default product gallery
        galleryViewerList.innerHTML = galleryEl._defaultSlidesHTML;
        if (galleryThumbnailsList && galleryEl._defaultThumbnailsHTML) {
          galleryThumbnailsList.innerHTML = galleryEl._defaultThumbnailsHTML;
        }
        if (sliderCounterTotal && galleryEl._defaultTotalCount) {
          sliderCounterTotal.textContent = galleryEl._defaultTotalCount;
        }
      }

      // Re-bind thumbnail click listeners for <media-gallery>
      if (galleryThumbnailsList) {
        galleryThumbnailsList.querySelectorAll('[data-target]').forEach(function (mediaToSwitch) {
          var btn = mediaToSwitch.querySelector('button');
          if (btn) {
            btn.addEventListener('click', function (evt) {
              evt.preventDefault();
              var targetId = mediaToSwitch.dataset.target;
              var targetSlide = galleryViewerList.querySelector('[data-media-id="' + targetId + '"]');
              if (targetSlide) {
                galleryViewerList.querySelectorAll('.product__media-item').forEach(function (item) {
                  item.classList.remove('is-active');
                });
                targetSlide.classList.add('is-active');
                galleryThumbnailsList.querySelectorAll('button').forEach(function (b) {
                  b.removeAttribute('aria-current');
                });
                btn.setAttribute('aria-current', 'true');
              }
              if (typeof galleryEl.setActiveMedia === 'function') {
                try {
                  galleryEl.setActiveMedia(targetId, false);
                } catch (err) {
                  // Suppress unhandled slide mismatch errors
                }
              }
            });
          }
        });
      }

      // Set active media: if user has not interacted yet, prioritize default hero slide (featured image)
      var targetSlide = null;
      if (!this._userInteracted) {
        targetSlide = galleryViewerList.querySelector('.product__media-item[data-default-hero="true"]') ||
                      galleryViewerList.querySelector('.product__media-item.is-active');
      }
      if (!targetSlide) {
        targetSlide = galleryViewerList.querySelector('.product__media-item');
      }

      if (targetSlide) {
        galleryViewerList.querySelectorAll('.product__media-item').forEach(function (item) {
          item.classList.remove('is-active');
        });
        targetSlide.classList.add('is-active');
        if (galleryThumbnailsList) {
          galleryThumbnailsList.querySelectorAll('button').forEach(function (b) {
            b.removeAttribute('aria-current');
          });
          var targetThumbBtn = null;
          if (targetSlide.dataset.mediaId) {
            var matchingThumbLi = galleryThumbnailsList.querySelector('[data-target="' + targetSlide.dataset.mediaId + '"]');
            if (matchingThumbLi) targetThumbBtn = matchingThumbLi.querySelector('button');
          }
          if (!targetThumbBtn) targetThumbBtn = galleryThumbnailsList.querySelector('button');
          if (targetThumbBtn) targetThumbBtn.setAttribute('aria-current', 'true');
        }
        if (typeof galleryEl.setActiveMedia === 'function' && targetSlide.dataset.mediaId) {
          try {
            galleryEl.setActiveMedia(targetSlide.dataset.mediaId, false);
          } catch (err) {
            // Suppress unhandled slide mismatch errors
          }
        }
      }

      // Safely re-sync SliderComponent references if component exists
      var sliderComponents = galleryEl.querySelectorAll('slider-component');
      sliderComponents.forEach(function (sc) {
        if (typeof sc.initPages === 'function') {
          try {
            sc.initPages();
          } catch (e) {}
        }
        if (typeof sc.resetPages === 'function') {
          try {
            sc.resetPages();
          } catch (e) {}
        }
      });

      if (this._userInteracted && typeof this.updateMainImage === 'function') {
        try {
          this.updateMainImage();
        } catch (e) {}
      }
    },

    initStickyGalleryObserver: function () {
      if (typeof window === 'undefined') return;

      var galleryEl = document.querySelector('.product--custom-tarps media-gallery') ||
                      document.querySelector('.custom-tarps-section media-gallery') ||
                      document.querySelector('media-gallery');
      if (!galleryEl) return;

      var getCtaElement = function () {
        return document.querySelector('.product-form__buttons') ||
               document.querySelector('.product-form__submit') ||
               document.getElementById('ProductSubmitButton');
      };

      var ctaEl = getCtaElement();

      var updateStickyElevation = function () {
        if (!window.matchMedia('(max-width: 749px)').matches) {
          galleryEl.classList.remove('is-sticky-active', 'is-unpinned-at-cta');
          return;
        }
        var initialTop = galleryEl.offsetTop || 0;
        if (window.scrollY > (initialTop + 15)) {
          galleryEl.classList.add('is-sticky-active');
        } else {
          galleryEl.classList.remove('is-sticky-active');
        }
      };

      if ('IntersectionObserver' in window) {
        var ctaObserver = new IntersectionObserver(function (entries) {
          if (!window.matchMedia('(max-width: 749px)').matches) {
            galleryEl.classList.remove('is-unpinned-at-cta');
            return;
          }
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              galleryEl.classList.add('is-unpinned-at-cta');
            } else {
              var cta = ctaEl || getCtaElement();
              if (cta) {
                var ctaRect = cta.getBoundingClientRect();
                if (ctaRect.top > 0) {
                  galleryEl.classList.remove('is-unpinned-at-cta');
                }
              } else {
                galleryEl.classList.remove('is-unpinned-at-cta');
              }
            }
          });
        }, {
          root: null,
          threshold: [0, 0.1],
          rootMargin: '0px 0px -40px 0px'
        });

        if (ctaEl) {
          ctaObserver.observe(ctaEl);
        } else {
          setTimeout(function () {
            var delayedCta = getCtaElement();
            if (delayedCta) ctaObserver.observe(delayedCta);
          }, 500);
        }
      }

      window.addEventListener('scroll', updateStickyElevation, { passive: true });
      window.addEventListener('resize', updateStickyElevation, { passive: true });
      updateStickyElevation();
    }
  };

  // Initialize when config is available
  function initColorSystem() {
    var configEl = document.getElementById('customTarpsConfigJson');
    if (!configEl) return;

    try {
      var config = JSON.parse(configEl.textContent);
      CustomTarpsColors.init(config);
    } catch (e) {
      console.error('Failed to parse custom tarps config:', e);
      var posMatch = e.message.match(/position (\d+)/);
      if (posMatch) {
        var pos = parseInt(posMatch[1], 10);
        var start = Math.max(0, pos - 80);
        var end = Math.min(configEl.textContent.length, pos + 80);
        console.error('JSON Error Snippet near position ' + pos + ':\n...' + configEl.textContent.slice(start, end) + '...');
      }
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initColorSystem);
  } else {
    initColorSystem();
  }
})();
